import React from 'react';

const HomePage = React.lazy(() => import('./pages/HomePage'));
const MyCarddassList = React.lazy(() => import('./pages/MyCarddassList'));
const CarddassDictionary = React.lazy(() => import('./pages/CarddassDictionary'));
const ComboPage = React.lazy(() => import('./pages/ComboPage'));
const ComboEntry = React.lazy(() => import('./components/Combo/ComboEntry'));

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/home', exact: true, name: 'ホーム', component: HomePage },
  { path: '/cards', name:'マイカード', component: MyCarddassList},
  { path: '/dictionary', name:'カード図鑑', component: CarddassDictionary},
  { path: '/combo', exact:true, name:'コンボ', component: ComboPage },
  { path: '/combo/new', name:'コンボの投稿', component: ComboEntry },
];

export default routes;
